document.addEventListener('DOMContentLoaded', function () {

    new Swiper('.okd-lp1-navigation .swiper', {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: false,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

    });

});

document.querySelectorAll('.okd-lp1-navigation a[href^="#"]:not([rel~="modal:open"])').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (!targetId || targetId === '#') return;

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
});